export enum SubmitOrderBlockReason {
  ALREADY_SUBMITTED = 'alreadySubmitted',
  ORDERING = 'ordering',
  SUBMISSION_TIMED_OUT = 'submissionTimedOut',
}
